// The signed-in person's access token for the shared EquaOS assistant, fresh.
//
// The assistant calls Hiring's MCP through the gateway as this person, so it
// asks for the token before each turn. On the school's own Hiring app the
// token is renewed here (standalone.js refresh) when it is about to run out;
// in the ERP shell, the shell renews it; anywhere else it is the stored one.

import { inShell, freshAccessToken as shellToken } from '../../shell';
import { standalone, refresh } from '../../standalone';

const MARGIN_SECONDS = 30;

/* Seconds left on a JWT, or 0 when it cannot be read. */
export function secondsLeft(token, now = Date.now()) {
  try {
    const part = String(token).split('.')[1];
    const json = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')));
    return Math.max(0, Math.floor(json.exp - now / 1000));
  } catch (e) {
    return 0;
  }
}

export async function freshAccessToken() {
  if (inShell) return shellToken();
  let token = null;
  try { token = localStorage.getItem('token'); } catch (e) { token = null; }
  if (token && secondsLeft(token) > MARGIN_SECONDS) return token;
  if (standalone) {
    try { return await refresh(); } catch (e) { return token; }
  }
  return token;
}
